module.exports = __webpack_public_path__ + "img/ctrl-p-stub-down-+.e9166679.svg";